import React from "react";
import "./cardtende.css";

export const CardTende = ({ id, cover, title }) => {
    return (
        <a href={`/InfoProyectos/${id}`}>
            <div className="card">
                <img src={cover} alt={title} className="imgcard" />
                <div className="card-content">
                    <div className="card-name">{title}</div>
                    <div className="card-stars">★★★★★</div>
                </div>
            </div>
        </a>

    );
};